var React = require('react');

function CaretDownInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"c"),React.createElement("g",{"id":"WWW","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Home","transform":"translate(-154.000000, -2092.000000)","fill":"#D37A0E","fillRule":"nonzero"},React.createElement("g",{"id":"🌲🌲🌲02","transform":"translate(0.000000, 1750.000000)"},React.createElement("path",{"d":"M164.8812,352.175002 L172.918717,344.131259 C173.706191,343.343785 173.149979,342.000038 172.037433,342.000038 L155.956233,342.000038 C154.843748,342.000038 154.287475,343.343785 155.07501,344.131259 L163.112466,352.175002 C163.599953,352.662488 164.393713,352.662488 164.8812,352.175002 Z","id":"c"}))))]);
}

CaretDownInline.defaultProps = {"width":"20px","height":"11px","viewBox":"0 0 20 11","version":"1.1"};

module.exports = CaretDownInline;

CaretDownInline.default = CaretDownInline;
